import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';
import { chooseProfileFilter } from '../../../../../helpers/chooseProfileFilter';
import { getUserSession } from '../../../../../util/core/Session';

const useLocations = (cityId) => {
    const profileFilter = chooseProfileFilter();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isCityManager =
        profile === config.default_foreign_key.sdg_profiles.cityManager;

    const governance_room_client_city_id = isCityManager
        ? profileFilter.governance_room_client_city_id
        : cityId;

    return useQuery({
        queryKey: ['locations', governance_room_client_city_id],
        queryFn: async () => {
            if (!governance_room_client_city_id) {
                return [];
            }

            return await Fetch.post(
                config.endpoints.backend +
                    'governanceroom/dashboard/establishments',
                {
                    filters: {
                        governance_room_client_city_id
                    }
                }
            );
        },
        enabled: !!governance_room_client_city_id
    });
};

export default useLocations;
